import { ReactElement } from 'react';

import AltProgramLayout from '@/components/app/program/AltProgramLayout';
import ProgramLayout from '@/components/app/program/ProgramLayout';
import { useProgramState } from '@/hooks/store';

export default function ProgramComponent(): ReactElement {
	const program = useProgramState();

	if (program && ['masterclass', 'body'].includes(program.meditation_type)) {
		return <AltProgramLayout program={program} />;
	}

	return <ProgramLayout program={program} />;
}
